export enum Role {
  Admin = "Admin",
  User = "EMDUser"
}
